/**
 * Adzuki.Erez.global
 */

(function Global($, Adzuki)
{
	"use strict";

	$(document).ready(function erezReady()
	{
		var $bottom_panel = $('.bottom-panel.show');

		// bottom panel show when scrolled to bottom
		if ($bottom_panel.length) {
			$(window).on('scroll', Adzuki.Debounce(function positionBottomPanel() {
				if ($(window).scrollTop() + $(window).height() === $(document).height()) {
					$bottom_panel.css('bottom', '45px');
				}
				else {
					$bottom_panel.css('bottom', '0px');
				}
			}, 500));
		}
	});

}(jQuery, window.Adzuki || {}));
